import React from 'react';
import { Outlet } from 'react-router-dom';
import { usePublicSettings } from '../../hooks/usePublicSettings';

interface AuthLayoutProps {
  children?: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { settings } = usePublicSettings();
  const brand = settings?.SITE_NAME || 'RiskMatrix';
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-paper px-4 py-8">
      <main className="w-full max-w-sm border border-ink bg-paper-raised p-6">
        <h1 className="font-serif text-scale-5 font-medium text-ink">{brand}</h1>
        <p className="text-scale-1 text-ink-muted">Enterprise risk, kept in order.</p>
        <div className="mt-2 border-b-2 border-ink" />
        <div className="mb-4 mt-0.5 border-b border-ink" />
        {children ?? <Outlet />}
      </main>
      <footer className="mt-4 font-serif text-scale-1 italic text-ink-muted">
        © {new Date().getFullYear()} {brand} · All rights reserved
      </footer>
    </div>
  );
};
